module.exports = __webpack_public_path__ + "static/media/emotion-after.b3d18823.png";